var _g, _g2, _g3, _g4, _g5, _g6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResumeAts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_77_1089)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5081 21.8713C13.5081 20.1613 13.5081 19.3063 13.7712 18.6262C14.1681 17.6005 14.979 16.7896 16.0047 16.3927C16.6848 16.1296 17.5398 16.1296 19.2498 16.1296H35.1077C36.8177 16.1296 37.6727 16.1296 38.3528 16.3927C39.3785 16.7896 40.1894 17.6005 40.5863 18.6262C40.8494 19.3063 40.8494 20.1613 40.8494 21.8713V30.2885H13.5081V21.8713Z",
    fill: "url(#paint0_linear_77_1089)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_77_1089)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.414,
    y: 11.8555,
    width: 5.85884,
    height: 7.81179,
    rx: 2.92942,
    fill: "#FFB7B5",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.5038,
    y: 11.9453,
    width: 5.67921,
    height: 7.63216,
    rx: 2.83961,
    stroke: "url(#paint1_linear_77_1089)",
    strokeWidth: 0.179628
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_77_1089)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.0847,
    y: 11.8555,
    width: 5.85884,
    height: 7.81179,
    rx: 2.92942,
    fill: "#FFB7B5",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.1745,
    y: 11.9453,
    width: 5.67921,
    height: 7.63216,
    rx: 2.83961,
    stroke: "url(#paint2_linear_77_1089)",
    strokeWidth: 0.179628
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_b_77_1089)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5081 27.8695C13.5081 25.682 13.5081 24.5883 13.9338 23.7528C14.3083 23.0178 14.9058 22.4203 15.6408 22.0458C16.4763 21.6201 17.57 21.6201 19.7575 21.6201H34.5999C36.7875 21.6201 37.8812 21.6201 38.7167 22.0458C39.4517 22.4203 40.0492 23.0178 40.4237 23.7528C40.8494 24.5883 40.8494 25.682 40.8494 27.8695V31.7754C40.8494 35.0567 40.8494 36.6973 40.2108 37.9506C39.6491 39.053 38.7528 39.9493 37.6504 40.511C36.3971 41.1496 34.7565 41.1496 31.4752 41.1496H22.8823C19.601 41.1496 17.9604 41.1496 16.7071 40.511C15.6047 39.9493 14.7084 39.053 14.1467 37.9506C13.5081 36.6973 13.5081 35.0567 13.5081 31.7754V27.8695Z",
    fill: "#FFB7B5",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7575 21.7099H34.5999C35.6952 21.7099 36.5112 21.71 37.158 21.7628C37.8038 21.8156 38.273 21.9205 38.6759 22.1259C39.394 22.4917 39.9778 23.0755 40.3436 23.7935C40.549 24.1965 40.6539 24.6657 40.7066 25.3115C40.7595 25.9583 40.7596 26.7743 40.7596 27.8695V31.7754C40.7596 33.4176 40.7595 34.6437 40.68 35.6162C40.6007 36.5876 40.4425 37.298 40.1308 37.9098C39.5777 38.9953 38.6951 39.8779 37.6096 40.431C36.9978 40.7427 36.2874 40.9009 35.316 40.9802C34.3435 41.0597 33.1173 41.0598 31.4752 41.0598H22.8823C21.2402 41.0598 20.014 41.0597 19.0415 40.9802C18.0701 40.9009 17.3597 40.7427 16.7479 40.431C15.6624 39.8779 14.7798 38.9953 14.2267 37.9098C13.915 37.298 13.7568 36.5876 13.6775 35.6162C13.598 34.6437 13.5979 33.4176 13.5979 31.7754V27.8695C13.5979 26.7743 13.598 25.9583 13.6508 25.3115C13.7036 24.6657 13.8085 24.1965 14.0139 23.7935C14.3797 23.0755 14.9635 22.4917 15.6815 22.1259C16.0845 21.9205 16.5537 21.8156 17.1995 21.7628C17.8463 21.71 18.6623 21.7099 19.7575 21.7099Z",
    stroke: "url(#paint3_linear_77_1089)",
    strokeWidth: 0.179628
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_b_77_1089)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33.0376,
    y: 27.479,
    width: 1.95295,
    height: 11.7177,
    rx: 0.976474,
    transform: "rotate(90 33.0376 27.479)",
    fill: "url(#paint4_linear_77_1089)",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.9657,
    y: 27.5509,
    width: 1.80924,
    height: 11.574,
    rx: 0.904622,
    transform: "rotate(90 32.9657 27.5509)",
    stroke: "url(#paint5_linear_77_1089)",
    strokeWidth: 0.143702
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_b_77_1089)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33.0376,
    y: 33.3379,
    width: 1.95295,
    height: 11.7177,
    rx: 0.976474,
    transform: "rotate(90 33.0376 33.3379)",
    fill: "url(#paint6_linear_77_1089)",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.9657,
    y: 33.4097,
    width: 1.80924,
    height: 11.574,
    rx: 0.904622,
    transform: "rotate(90 32.9657 33.4097)",
    stroke: "url(#paint7_linear_77_1089)",
    strokeWidth: 0.143702
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_77_1089",
    x: 9.60222,
    y: 12.2237,
    width: 35.153,
    height: 21.9707,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.95295
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_77_1089"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_77_1089",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_77_1089",
    x: 13.5081,
    y: 7.94957,
    width: 13.6706,
    height: 15.6236,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.95295
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_77_1089"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_77_1089",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_77_1089",
    x: 27.1788,
    y: 7.94957,
    width: 13.6706,
    height: 15.6236,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.95295
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_77_1089"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_77_1089",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_b_77_1089",
    x: 9.60222,
    y: 17.7142,
    width: 35.153,
    height: 27.3413,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.95295
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_77_1089"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_77_1089",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_b_77_1089",
    x: 17.414,
    y: 23.5731,
    width: 19.5295,
    height: 9.76467,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.95295
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_77_1089"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_77_1089",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_b_77_1089",
    x: 17.414,
    y: 29.432,
    width: 19.5295,
    height: 9.76467,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.95295
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_77_1089"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_77_1089",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_77_1089",
    x1: 10.6523,
    y1: 23.2196,
    x2: 19.1369,
    y2: 31.4264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F52828"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_77_1089",
    x1: 17.1211,
    y1: 12.4135,
    x2: 23.2258,
    y2: 19.4061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_77_1089",
    x1: 30.7917,
    y1: 12.4135,
    x2: 36.8964,
    y2: 19.4061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_77_1089",
    x1: 12.1411,
    y1: 23.0151,
    x2: 23.9626,
    y2: 48.2917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_77_1089",
    x1: 36.4546,
    y1: 26.096,
    x2: 33.9398,
    y2: 37.2329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_77_1089",
    x1: 34.0141,
    y1: 27.479,
    x2: 34.0141,
    y2: 39.1967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_77_1089",
    x1: 35.6253,
    y1: 33.2122,
    x2: 33.8291,
    y2: 42.5529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_77_1089",
    x1: 34.0141,
    y1: 33.3379,
    x2: 34.0141,
    y2: 45.0556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResumeAts);
export default __webpack_public_path__ + "static/media/resume_ats.8f00e9b63bfde87e3832444f0d4859b8.svg";
export { ForwardRef as ReactComponent };